module.exports = __webpack_public_path__ + "img/sld_scb_1_green.819e54fd.svg";